import { useId, type ComponentPropsWithRef } from "react";

import { Input } from "./Input";

interface FieldProps extends ComponentPropsWithRef<"input"> {
  error?: string;
  label: string;
}

export function Field({
  "aria-describedby": ariaDescribedBy,
  "aria-invalid": ariaInvalid,
  error,
  id: providedId,
  label,
  ...input
}: FieldProps) {
  const generatedId = useId();
  const id = providedId ?? generatedId;
  const errorId = `${id}-error`;
  const describedBy = [ariaDescribedBy, error ? errorId : undefined].filter(Boolean).join(" ");

  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={id} className="text-sm font-semibold text-foreground">
        {label}
      </label>
      <Input
        id={id}
        aria-describedby={describedBy || undefined}
        aria-invalid={error ? true : ariaInvalid}
        {...input}
      />
      {error && (
        <p id={errorId} role="alert" className="text-sm font-medium text-danger">
          {error}
        </p>
      )}
    </div>
  );
}
